module.exports = {"master":{"setings":"Settings"},"masterCustomer":{"listMasterDataCustomer":"List Customer","createMasterDataCustomer":"Create Customer","updateMasterDataCustomer":"Update Customer","viewMasterDataCustomer":"Detail Customer","name":"Name","address":"Address","contactNo":"Contact No","contactName":"Contact Name","createCustomer":"Create Customer","":""}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/master.json
// module id = 732
// module chunks = 116